import React, { useEffect, useState } from 'react';

import IconLike from '@components/Images/Rebranding/IconLike';
import useCommentLikersText from '@hooks/useCommentLikersText';
import useServerSideRendering from '@hooks/useServerSideRendering';
import MuiTooltip from '@mui/material/Tooltip';

export default function LikesCount({ count, commentId }: { commentId: number; count: number }) {
  const hydrated = useServerSideRendering();
  const [enabled, setEnabled] = useState(false);
  const { likersFor } = useCommentLikersText(commentId, enabled);

  useEffect(() => {
    if (!enabled && count > 0) {
      setEnabled(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [count]);

  if (!hydrated) return;

  return (
    <MuiTooltip arrow placement="top" title={likersFor || ''} disableHoverListener={!enabled}>
      <span className="flex items-center gap-8">
        <IconLike className="w-16" />
        {count > 0 && <span>{count}</span>}
      </span>
    </MuiTooltip>
  );
}
